import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

import { cloneDeep } from 'lodash';

import { EnumerationModel } from '@bayclubs/court-booking-employee-api';

@Component({
    selector: 'app-enumeration-filter',
    templateUrl: './enumeration-filter.component.html',
    styleUrls: ['./enumeration-filter.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: EnumerationFilterComponent, multi: true }],
    standalone: false
})
export class EnumerationFilterComponent implements OnInit, ControlValueAccessor {
    innerItems: EnumerationModel[] = [];
    @Input() set items(value: EnumerationModel[]) {
        this.innerItems = cloneDeep(value);
    }
    get items(): EnumerationModel[] {
        return this.innerItems;
    }

    public selectedCodes: string[] = [];

    constructor() { }

    ngOnInit(): void { }

    onChange = (codes: string[]) => { };
    onTouched = () => { };

    registerOnChange(fn: (codes: string[]) => void): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: () => void): void {
        this.onTouched = fn;
    }

    writeValue(value: string[]): void {
        const codes = value ?? [];
        this.selectedCodes = [...this.items.filter(x => codes.indexOf(x.code) >= 0).map(x => x.code)];
        this.onChange(this.selectedCodes);
    }

    public onSelectItem(item: EnumerationModel) {
        const indexOfSelectedCode = this.indexOfSelectedItem(item);
        this.selectedCodes = cloneDeep(this.selectedCodes);
        if (indexOfSelectedCode >= 0) {
            this.selectedCodes.splice(indexOfSelectedCode, 1);
        } else {
            this.selectedCodes.push(item.code);
        }

        this.onChange(this.selectedCodes);
    }

    public isItemSelected(item: EnumerationModel) {
        return this.selectedCodes && this.indexOfSelectedItem(item) >= 0;
    }

    private indexOfSelectedItem(item: EnumerationModel) {
        return this.selectedCodes.findIndex(x => x === item.code);
    }
}
